module.exports = __webpack_public_path__ + "img/icon284.7ab2adb1.png";